<template>
  <div class="toast-container">
    <toast-notification
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script>
import ToastNotification from './ToastNotification.vue'

export default {
  name: 'ToastContainer',
  components: {
    ToastNotification
  },
  data() {
    return {
      toasts: [],
      nextId: 1
    }
  },
  methods: {
    addToast(message, type = 'info', duration = 3000) {
      const id = this.nextId++
      this.toasts.push({ id, message, type, duration })
    },
    removeToast(id) {
      const index = this.toasts.findIndex(t => t.id === id)
      if (index > -1) {
        this.toasts.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  pointer-events: none;
}

.toast-container > * {
  pointer-events: auto;
  margin-bottom: 10px;
}
</style>
